export default __webpack_public_path__ + "static/media/iconGooglePlay.3b76df50.svg";